import React, { useState, useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
//components
import BatchInfo from "../Admin_V/BatchDetailsCompoents/batchInfo.js";
import Card from "../Admin_V/BatchDetailsCompoents/card";
//table
import SimTable from "../Admin_V/BatchDetailsCompoents/SimTable.js";
import SimTableFilters from "../Admin_V/BatchDetailsCompoents/SimTableFilters.js";
//fetch
import useFetch from "../../hooks/useFetch.js";
import { StepForward, StepBack } from "lucide-react";
import axios from "axios";
const SimsPage = () => {
  const [batchDetails, setBatchDetails] = useState(null); 
  const [queryParams, setQueryParams] = useState("");
  const [filters, setFilters] = useState({
    SN: "",
    status: "",
    ICCID: "",
    page: 1,
    limit: 10,
  });
  const { id } = useParams();
  const location = useLocation();
  const {
    data: sims,
    error,
  } = useFetch(
    `${process.env.REACT_APP_BACKEND_URL}/sims/${id}?${queryParams}`
  );


const getBatchDetails = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/getBatchDetails` , {
        withCredentials: true,
        params: {
          id: id,
        },
      }
    );
    setBatchDetails(response.data);
  } catch (error) {
    console.error("Error fetching batch details:", error);
    setBatchDetails(null); // Handle error case
  }
}


  const handleFilterChange = (key, value) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [key]: value,
      page: 1, // Reset to the first page when filters change
    }));
  };

  const handlePageChange = (newPage) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      page: newPage,
    }));
  };

 
  useEffect(() => {
    const params = new URLSearchParams();
    if (filters.SN) params.append("SN", filters.SN);
    if (filters.status) params.append("status", filters.status);

    // Add pagination defaults
    params.append("page", filters.page);
    params.append("limit", filters.limit);

    setQueryParams(params.toString());
  }, [filters]);

  useEffect(() => {
    getBatchDetails();
  },[])

  return (
    <div>
      <div className="  dark:bg-gray-900">
        <div class="grid w-full grid-cols-1 gap-4 mt-4 xl:grid-cols-2 2xl:grid-cols-1 mb-4">
          <div className="items-center justify-between p-4 bg-white border border-gray-200 rounded-lg shadow-sm sm:flex dark:border-gray-700 sm:p-6 dark:bg-gray-800 mb-2">
            <div className="w-full sm:w-1/2 p-2">
              <span className="text-2xl font-bold leading-none text-gray-900 sm:text-3xl dark:text-white">
                Batch details
              </span>
            </div>
          </div>
        </div>
      </div>
      {/* // stats wrapper */}
      <div className="md:flex md: flex-row grid gap-4 ">
        <BatchInfo batch={location.state}></BatchInfo>
        <div className="grid gap-4  w-1/4">
          <Card title={"TRANSACTIONS"} data={batchDetails?.transactions_count}></Card>
          <Card title={"CARTES SIMS"} data={batchDetails?.sims_count}></Card>
          <Card title={"SIMS DISPONIBLE"} data={batchDetails?.holder_sims_count}></Card>
        </div>
        <div className=" rounded-md p-4 hidden md:flex flex-col gap-4 items-center justify-center bg-white w-full  dark:bg-gray-800 border border-gray-200 dark:border-gray-700 shadow-sm sm:p-6 mb-2 dark:text-white">
          <span className="text-2xl font-bold font-poppins" >Quantity</span>
          <span className="text-xl font-bold font-poppins">{location.state.quantity}</span>
        </div>
      </div>
      <div className="  dark:bg-gray-900">
        <div class="grid w-full grid-cols-1 gap-4 mt-4 xl:grid-cols-2 2xl:grid-cols-1 mb-4">
          <div className="items-center justify-between p-4 bg-white border border-gray-200 rounded-lg shadow-sm sm:flex dark:border-gray-700 sm:p-6 dark:bg-gray-800 mb-2">
            <div className="w-full sm:w-1/2 p-2">
              <span className="text-2xl font-bold leading-none text-gray-900 sm:text-3xl dark:text-white">
                Cartes Sims
              </span>
            </div>
          </div>
        </div>
      </div>
      <SimTableFilters
        filters={filters}
        onFilterChange={handleFilterChange}></SimTableFilters>
      <SimTable sims={error ? [] : sims?.data}></SimTable>
      {/* Pagination Controls */}
      <div className="flex  gap-4 items-center justify-between px-4 bg-white rounded-md py-3 mt-3 dark:bg-gray-800 dark:text-white">
        <div className="flex items-center space-x-2 ">
          <button
            disabled={filters.page === 1}
            onClick={() => handlePageChange(filters.page - 1)}
            className="px-2 py-2 bg-slate-500 text-white rounded disabled:opacity-50 cursor-pointer">
            <StepBack size={12}></StepBack>
          </button>
          <span className="text-gray-700 dark:text-gray-300">
            Page {filters.page} / {sims?.pagination?.totalPages}
          </span>
          <button
            disabled={!sims?.data?.length || sims?.data?.length < filters.limit}
            onClick={() => handlePageChange(filters.page + 1)}
            className="px-2 py-2 bg-slate-500 text-white rounded disabled:opacity-50 cursor-pointer">
            <StepForward size={12}></StepForward>
          </button>
        </div>
        <span className="dark:text-white">
          Totale :{sims?.pagination?.total}
        </span>
      </div>
    </div>
  );
};

export default SimsPage;
